import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, SadieSimulatorTesters } from "@/types";

export const sadieSimulatorTestersQueryKey = [
  "sadie-simulator-testers",
] as const;

export function useGetSadieSimulatorTesters() {
  return useQuery({
    queryKey: sadieSimulatorTestersQueryKey,
    queryFn: async () => {
      const res = await guacHttpClient.get<
        SadieSimulatorTesters,
        HttpResponse<SadieSimulatorTesters>
      >("relationships/simulator/testers");
      return res.data;
    },
  });
}
